import { CouponType } from '@tencent/wphk-act-base-types';
import { CouponType as CouponTypeUI } from '@tencent/wphk-act-base-ui';

/** 将原始值couponType map为UI的couponType */
export function mapCouponType(rawType?: CouponType): CouponTypeUI {
  switch (rawType) {
    case CouponType.FIXED:
      return CouponTypeUI.cash; // 现金券
    case CouponType.DISC:
      return CouponTypeUI.discount; // 折扣券
    default:
      return CouponTypeUI.default;  // 默认
  }
}
